import { service } from '../../helpers/http'
import state from './store/state'
import mutations from './store/mutations'
import * as baseActions from './store/actions'

const ActionAlgorithmRunsAmbienceBalanceGroups = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'listAmbienceBalanceRunGroups',
    idAndPayload: true,
    payload,
  })
}

const ActionAlgorithmRunsAmbienceBalanceResults = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'resultsAmbienceBalanceRun',
    idAndPayload: true,
    payload,
  })
}

const ActionAlgorithmRunsAmbienceBalanceUnassigned = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'unassignedAmbienceBalanceRun',
    idAndPayload: true,
    payload,
  })
}

const ActionAlgorithmRunsAmbienceBalanceSummary = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'summaryAmbienceBalanceRun',
    idAndPayload: true,
    payload,
  })
}

const ActionAlgorithmRunsAmbienceBalanceApply = ({ dispatch }, payload) => {
  const body = {}
  if (payload && payload.mode) {
    body.mode = payload.mode
  }
  return service({
    module: 'algorithmRuns',
    action: 'applyAmbienceBalanceRun',
    params: { id: payload.id },
    payload: body,
  })
}

const ActionAlgorithmRunsAmbienceBalanceDashboard = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'dashboardAmbienceBalanceRun',
    idAndPayload: true,
    payload,
  })
}

const ActionAlgorithmRunsApplyStatus = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'applyStatusRun',
    params: { id: payload.id },
    payload: {},
  })
}

const ActionAlgorithmRunsApplications = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'listApplications',
    payload,
  })
}

export default {
  namespaced: true,
  state,
  mutations,
  actions: {
    ...baseActions,
    ActionAlgorithmRunsAmbienceBalanceGroups,
    ActionAlgorithmRunsAmbienceBalanceResults,
    ActionAlgorithmRunsAmbienceBalanceUnassigned,
    ActionAlgorithmRunsAmbienceBalanceSummary,
    ActionAlgorithmRunsAmbienceBalanceApply,
    ActionAlgorithmRunsAmbienceBalanceDashboard,
    ActionAlgorithmRunsApplyStatus,
    ActionAlgorithmRunsApplications,
  },
}
